import { createContext, type ReactNode, useContext } from 'react';

type MarketingAnnouncementControls = {
  openAnnouncement(): void;
};

const MarketingAnnouncementControlsContext =
  createContext<MarketingAnnouncementControls>({
    openAnnouncement: () => undefined,
  });

export function MarketingAnnouncementControlsProvider({
  children,
  openAnnouncement,
}: {
  children: ReactNode;
  openAnnouncement(): void;
}) {
  return (
    <MarketingAnnouncementControlsContext.Provider value={{ openAnnouncement }}>
      {children}
    </MarketingAnnouncementControlsContext.Provider>
  );
}

export function useMarketingAnnouncementControls() {
  return useContext(MarketingAnnouncementControlsContext);
}
